import GridOptions from './GridOptions';
import MuiGrid from '../../../../../../../UI/MuiGrid/MuiGrid';
import { icons } from '../../../../../../../../../shared/icons';
import { formatDateFromDB } from '../../../../../../../../../utils/FormatDate';
import { useTranslation } from 'react-i18next';

const GridProvider = ({
  data,
  loading,
  handleOpenFile,
  handleOpenDeleteDialog,
  downloadFile,
}) => {
  const { t, i18n } = useTranslation();
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: '',
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          openFile={() => handleOpenFile(e.row)}
          handleOpenDeleteDialog={() => handleOpenDeleteDialog(e.id)}
          downloadFile={() => downloadFile(e.row.path, e.row.name)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    {
      field: 'nazivVrsteDokOpste',
      headerName: t('mainCategory'),
      width: 300,
    },
    {
      field: 'kategorija',
      headerName: t('category'),
      width: 200,
    },
    {
      field: 'nazivJezika',
      headerName: t('language'),
      width: 200,
    },
    {
      field: 'datumDokumenta',
      headerName: t('date'),
      width: 150,
      renderCell: (item) => {
        return (
          <span>
            {item.row.datumDokumenta
              ? formatDateFromDB(item.row.datumDokumenta)
              : null}
          </span>
        );
      },
    },
    {
      field: 'nazivFajla',
      headerName: t('fileName'),
      width: 300,
    },
    {
      field: 'size',
      headerName: t('fileSize'),
      width: 100,
      renderCell: (item) => {
        return <span>{(item.row.size / 1024 ** 2).toFixed(2)} MB</span>;
      },
    },
  ];
  return (
    <div
      style={{
        marginTop: '10px',
        height: '400px',
        width: '99%',
      }}
    >
      <MuiGrid data={data} loading={loading} columns={columns} />
    </div>
  );
};

export default GridProvider;
